var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useState } from 'react';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import withWidth from '@material-ui/core/withWidth';
import { withStyles } from '@material-ui/core';
import { NavLink } from 'react-router-dom';
import { dateTransSerial } from 'consts';
import styled from 'styled-components';
import { Title } from 'component/title/Title';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { setAnnouncementsRedux } from 'reducers/sharedata/action';
import { getAnnouncementsRedux } from 'reducers/sharedata/selector';
import { getAnnouncement } from 'main_api';
import { dDaFms } from 'component/material/DatePicker/enum';
var StyleGridList = withStyles({
    root: {
        margin: '0 !important',
        borderLeft: '1px solid #dfdfdf',
        borderTop: '1px solid #dfdfdf',
    },
})(GridList);
var StyleGridListTile = withStyles({
    root: {
        borderRight: '1px solid #dfdfdf',
        borderBottom: '1px solid #dfdfdf',
        '& h3': {
            transition: 'color .5s',
        },
        '&:hover': {
            backgroundColor: '#f5f6fb',
            '& h3': {
                color: '#ffba02',
            },
        },
    },
    tile: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
    },
})(GridListTile);
var StyleNavLink = styled(NavLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n  text-decoration: none;\n  font-size: 1.4em;\n  color: #544227;\n  h3 {\n    color: rgb(0, 134, 218);\n    margin-top: 0;\n    margin-bottom: 5px;\n  }\n  small {\n    color: rgb(102, 102, 102);\n  }\n  p {\n    color: #333;\n    font-size: 1em;\n    line-height: 1.4em;\n    margin-bottom: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  height: 100%;\n  width: 100%;\n  text-decoration: none;\n  font-size: 1.4em;\n  color: #544227;\n  h3 {\n    color: rgb(0, 134, 218);\n    margin-top: 0;\n    margin-bottom: 5px;\n  }\n  small {\n    color: rgb(102, 102, 102);\n  }\n  p {\n    color: #333;\n    font-size: 1em;\n    line-height: 1.4em;\n    margin-bottom: 0;\n  }\n"])));
var Announcement = function (props) {
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var dispatch = useDispatch();
    var announcementData = useSelector(getAnnouncementsRedux);
    var width = props.width;
    var _a = useState(announcementData), announcementArray = _a[0], setNewsArray = _a[1];
    var cols = width === 'xs' || width === 'sm' ? 1 : 3;
    if (announcementArray.length === 1)
        cols = 1;
    else if (announcementArray.length === 2)
        cols = width === 'xs' || width === 'sm' ? 1 : 2;
    var init = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!(announcementData.length === 0)) return [3 /*break*/, 2];
                    _a = dispatch;
                    _b = setAnnouncementsRedux;
                    return [4 /*yield*/, getAnnouncement(enqueueSnackbar)];
                case 1:
                    _a.apply(void 0, [_b.apply(void 0, [_c.sent()])]);
                    _c.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        init();
    }, []);
    useEffect(function () {
        setNewsArray(announcementData);
    }, [announcementData]);
    return (React.createElement("div", null,
        React.createElement(Title, { title: "\u91CD\u8981\u8A0A\u606F\u516C\u544A\u200B" }),
        React.createElement(StyleGridList, { cols: cols, cellHeight: "auto", spacing: 30 }, announcementArray === null || announcementArray === void 0 ? void 0 : announcementArray.map(function (obj) {
            var link = '#';
            return (React.createElement(StyleGridListTile, { key: obj.subject },
                React.createElement(StyleNavLink, { to: link },
                    React.createElement("h3", null, obj.subject),
                    React.createElement("small", null, dateTransSerial(obj.validSDate, dDaFms)),
                    React.createElement("p", { dangerouslySetInnerHTML: { __html: obj.context } }))));
        }))));
};
export default withWidth()(Announcement);
var templateObject_1;
